import { AmplifyUser } from "@aws-amplify/ui";
import { isGroupMember, UserGroup } from "../../../data/ACL";

// Who sees the rebounding board and who uploads to it (Trevor, 2026-10-05). Coaches view; ReboundingDashboardUsers
// and the dev team also upload, edit, manage players and see hidden players. The backend enforces the same lists on the verified
// token (nba_explorer/app/api/rebounding/config.py VIEW_GROUPS / UPLOAD_GROUPS); this only hides what would 403.
export const canViewRebounding = (user?: AmplifyUser): boolean =>
  isGroupMember(user, UserGroup.Coaches, UserGroup.DevTeam, UserGroup.ReboundingDashboardUsers);

export const canUploadRebounding = (user?: AmplifyUser): boolean =>
  isGroupMember(user, UserGroup.DevTeam, UserGroup.ReboundingDashboardUsers);
